import { InjectionToken } from '@angular/core';

export interface EnvironmentConfig {
  production: boolean;
  apiBaseUrl: string;
  apiBaseUrlNibrasOne?: string;
  apiBaseFolder: string;
  client_id: string;
  version?: string;
  buildTime?: Date;
  ticketAppId?: number;
  roleDelegateAppId?: number;
}

export const ENV_CONFIG = new InjectionToken<EnvironmentConfig>('EnvironmentConfig');
